import React from "react";
import { useT } from "@racoon/i18n";
import { StatusPill } from "@racoon/ui";
import { ConnectProto } from "@racoon/api";
import { shiftStatusLabel, shiftStatusTone } from "../helpers";

interface ShiftStatusBadgeProps {
  status: ConnectProto.DriverOnShiftStatus;
  /** `isTtnApproved(shift)` — relabels an ended shift as "TTN approved". */
  ttnApproved?: boolean;
}

/** The shift's status as a pill, shown in the cascade and on the truck card. */
export const ShiftStatusBadge: React.FC<ShiftStatusBadgeProps> = ({ status, ttnApproved }) => {
  const t = useT();

  return (
    <StatusPill data-testid="shift-status-badge" tone={shiftStatusTone(status).badge}>
      {shiftStatusLabel(status, t, ttnApproved)}
    </StatusPill>
  );
};
